import { useState } from 'react';
import { localTime, fileFormatNames, bytesToView, imageSource, removeEmailFromValue, downloadFile } from '@helpers';
import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types.d';
import i18n from 'i18n-js';
import { useAppDispatch } from '@store/hooks/useAppDispatch';

interface UseManageInfoModalParams {
  images: ImageDocumentStoreItem[];
  selectedIndex: number;
}

export const useManageInfoModal = ({ images, selectedIndex }: UseManageInfoModalParams) => {
  const [shareFileLoading, setShareFileLoading] = useState(false);

  const image = images[selectedIndex];

  // const [image, setImage] = useState(images[selectedIndex]);
  // const id = image?.documentId || image?.id;
  // const [imageLoaded, setImageLoaded] = useState(!id);

  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   (async () => {
  //     const resp: ODataDocument[] = await dispatch(getDocumentById(id));
  //     if (resp?.[0]) {
  //       const i = resp[0];
  //       const cropped = i?.cropSettings?.some((c) => c.pageNumber == i.pageNumber); // TODO: check, maybe correct naming is imageCropSettings
  //       const imageLink = await dispatch(
  //         generateImageURL({
  //           size: '_2x',
  //           cropped,
  //           item: {
  //             imageHash: i.contentHash,
  //             ...i,
  //           },
  //           page: i.pageNumber,
  //         })
  //       );

  //       const imageLinkOriginal = await dispatch(
  //         generateImageURL({
  //           size: '_large',
  //           cropped: false,
  //           item: {
  //             imageHash: i.contentHash,
  //             ...i,
  //           },
  //           page: i.pageNumber,
  //           download: true,
  //         })
  //       );
  //       console.log(imageLinkOriginal, 'imageLinkOriginal');
  //       setImage({
  //         ...image,
  //         ...i,
  //         tags: i.tags,
  //         url: imageLink,
  //         urlOriginal: imageLinkOriginal,
  //         updatedAt: i.modifiedOn,
  //         sourceName: i.sourceName,
  //         originalLocation: i.filePath,
  //       });
  //       setImageLoaded(true);
  //     }
  //   })();
  // }, []);

  const date = (d: string) => localTime(d).format('DD MMMM YYYY HH:mm');

  const createdAt = date(image.createdOn);
  const modifiedAt = date(image.modifiedOn);
  const createdBy = image.createdBy;
  const modifiedBy = image.modifiedBy;
  const shouldHideModifiedLines = createdBy === modifiedBy && createdAt === modifiedAt;

  const parsedCreatedBy = removeEmailFromValue(createdBy);
  const parsedModifiedBy = removeEmailFromValue(modifiedBy);
  const parsedSubtitle = removeEmailFromValue(image.subTitle);
  const isCropped = image?.isCropped;

  const shouldHideName = image.source === imageSource.AppCameraOrPhotoLibrary || isCropped;

  const infoData = [
    { name: 'Name', value: image.title, hide: shouldHideName },
    { name: 'Kind', value: i18n.t(fileFormatNames[image.extensionOriginal as keyof typeof fileFormatNames]) },
    { name: 'Size', value: bytesToView(image.fileSize) },
    { name: 'Document Type', value: image.documentType },
    { name: 'Source', value: parsedSubtitle },
    // { name: 'Device', value: image.device },
    { name: 'Size', value: bytesToView(image.fileSize) },
    { name: 'Created', value: createdAt },
    { name: 'Created by', value: parsedCreatedBy },
    { name: 'Modified', value: modifiedAt, hide: shouldHideModifiedLines },
    { name: 'Modified by', value: parsedModifiedBy, hide: shouldHideModifiedLines },
    { name: 'Pages', value: image.pageCount, hide: image.pageCount == null || image.pageCount < 2 }, // TODO: maybe correct naming is pagesCount?
  ];

  const shareFile = async () => {
    setShareFileLoading(true);
    try {
      await downloadFile({ fileUrl: image.originUrl, fileName: image.fileName, fileType: image.extensionOriginal });
    } catch (error) {
      console.error(error);
    } finally {
      setShareFileLoading(false);
    }
  };

  return { infoData, shareFile, shareFileLoading, image };
};
